import { render, staticRenderFns } from "./DeptSaleInputModal.vue?vue&type=template&id=bca76568&scoped=true"
import script from "./DeptSaleInputModal.vue?vue&type=script&lang=js"
export * from "./DeptSaleInputModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca76568",
  null
  
)

export default component.exports